import React from 'react';
import './ClassGroupingModal.css';

const ClassGroupingModal = ({ isOpen, onClose, students }) => {
  if (!isOpen) return null;

  // Calculate class counts
  const calculateClassCounts = () => {
    const activeStudents = students.filter(s => !s.isDeleted);

    const kelasCounts = activeStudents.reduce((acc, student) => {
      const kelas = student.class || 'Unknown';
      const jantina = (student.jantina || '').toUpperCase();

      if (!acc[kelas]) {
        acc[kelas] = { total: 0, lelaki: 0, perempuan: 0 };
      }

      acc[kelas].total += 1;

      if (jantina === 'L') {
        acc[kelas].lelaki += 1;
      } else if (jantina === 'P') {
        acc[kelas].perempuan += 1;
      }

      return acc;
    }, {});

    return kelasCounts;
  };

  const kelasCounts = calculateClassCounts();

  // Handle clicking outside the modal to close it
  const handleOverlayClick = (e) => {
    if (e.target.classList.contains('kelas-overlay')) {
      onClose();
    }
  };

  return (
    <div className="kelas-overlay" onClick={handleOverlayClick}>
      <div className="kelas-overlay-content">
        <span className="close-btn" onClick={onClose}>&times;</span>
        <h3>Kelompok Mengikut Kelas</h3>
        <div id="kelasCounts">
          <table className="kelas-table">
            <thead>
              <tr>
                <th>Kelas</th>
                <th>Jumlah Pelajar</th>
                <th>Lelaki</th>
                <th>Perempuan</th>
              </tr>
            </thead>
            <tbody>
              {Object.entries(kelasCounts).length > 0 ? (
                Object.entries(kelasCounts).map(([kelas, counts]) => (
                  <tr key={kelas}>
                    <td>{kelas}</td>
                    <td>{counts.total}</td>
                    <td>{counts.lelaki}</td>
                    <td>{counts.perempuan}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" style={{ textAlign: 'center', padding: '20px' }}>
                    Tiada data pelajar
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default ClassGroupingModal;
